import React from "react";
import { MenuOutlined } from "@ant-design/icons";

export const ContainerApp = (props) => {
    const[VALOR,MODIFICAR_VALOR] = props.VARIABLES()

    const EVENTO_MODIFICAR_MENU = () => {
        MODIFICAR_VALOR(VALOR === props.ANCHO_MENU_GRANDE ? props.ANCHO_MENU_PQ : props.ANCHO_MENU_GRANDE)
      }

    return <>
        <div className="containerApp" style={{ width: `calc(100% - ${VALOR}px)` }}>
            <div className="headerApp">
                <div className='header_item1'>
                    <MenuOutlined onClick={() => { EVENTO_MODIFICAR_MENU() }}></MenuOutlined>

                    <div id="tituloMenu"></div>
                </div>
            </div>

            <div className="bodyApp">
                {props.COMPONENT}
            </div>

            <div className="footerApp" id="footerApp">

            </div>
        </div>

    </>;
};